/**
 * Adapted from HubSpot/shared-worker-versioning:
 * https://git.hubteam.com/HubSpot/shared-worker-versioning/blob/57e61b29a3a3a29537d4d43509bfc1f1cff89bdb/shared-worker-versioning/static/js/lib/utils/createWorker.ts#L27-L50
 */

export function createWorkerFallback(options) {
  let worker = null;
  try {
    let blob;
    try {
      blob = new Blob([`importScripts('${options.url}');`], {
        type: 'application/javascript'
      });
    } catch (error) {
      return {
        error,
        worker: null
      };
    }
    const url = window.URL || window.webkitURL;
    const blobUrl = url.createObjectURL(blob);
    worker = new Worker(blobUrl, {
      credentials: 'include',
      name: getWorkerName(options.cardTitle)
    });
  } catch (error) {
    return {
      error,
      worker: null
    };
  }
  return {
    worker,
    error: null
  };
}
function getWorkerName(cardTitle) {
  if (!cardTitle) {
    return undefined;
  }
  return `UI Extension: ${cardTitle}`;
}
export function createWorker({
  url,
  cardTitle
}) {
  if (!url.startsWith('http')) throw new Error('Supplied worker url must be absolute');
  let result = {
    worker: null,
    error: null
  };
  try {
    result.worker = new Worker(url, {
      credentials: 'include',
      name: getWorkerName(cardTitle)
    });
    result.worker.onerror = function (event) {
      event.preventDefault();
      result = createWorkerFallback({
        url,
        cardTitle
      });
    };
  } catch (e) {
    result = createWorkerFallback({
      url,
      cardTitle
    });
  }
  return result;
}